// --------------------------------------------------------
// src/collections/book.collection.js
//
// Ordered sets of Book models.
// Include filtering methods, basic pagination and simple
// query methods.
//
// --------------------------------------------------------
"use strict";

const BookCollection = Backbone.Collection.extend({
	model: BookModel,

	// Allows the program to display a maximum number of books
	// Used for the pagination module
	// TODO: move this parameter to a view, has nothing to do with the description of a book collection
	perPage: 12,

	// Shuffle the collection
	randomize: function() {
		// Shuffle the current collection
		var books = this.shuffle();
		// Return a new instance of the collection
		return new BookCollection(books);
	},

	// Remove empty (default model) books from the collection
	clean: function() {
		var pure = this.where(function(book){
			return !_.isEqual( book.toJSON(), new BookModel().toJSON() );
		});
		return new BookCollection(pure);
	},

	// Filter the books by its attribute
	filterBy: function(attribute, values) {
		// Filter the collection to keep only the items whose attributes matches the given values
		// First, loop trough every books of the collection
		let filtered = this.where(function(book) {
			// Only the books that pass the test will be kept
			return values.some(function(el) {
			    return _.contains(_.iterateValues(book.get(attribute), "", []), el);
			});
		});

		// Return a new collection containing the filtered books
		return new BookCollection(filtered);
	},

	// Generic search of the collection
	find: function(attr, values) {
		var collection = this;
		return collection.search(values, [attr]).models;
	},

	// Taken from Backbone Collection Search
	// https://www.npmjs.com/package/backbone-collection-search
	matcher: function(needle, haystack) {
		if (!needle || !haystack) return;
		needle = needle.toString().toLowerCase();
		haystack = haystack.toString().toLowerCase();
		return haystack.indexOf( needle ) >= 0;
	},

	// Paginate the collection
	paginate: function(page) {
		// A copy of this object
		var collection = this;

		if (page === 0) {
			collection = collection.first(this.perPage);
			return new BookCollection(collection);
		}
		// Return the rest of the 12 (perPage) first elements of the collection from a specific index (perPage * page)
		collection = collection.rest(this.perPage * (page - 1))
					 .slice(0, this.perPage);

		return new BookCollection(collection);
	},

	// Taken from Backbone Collection Search
	// https://www.npmjs.com/package/backbone-collection-search
	search: function(keyword, attributes) {
		if (!keyword || keyword[0] === null) return window.BOOKCOLLECTION;
		// If collection empty get out
		if (!this.models.length) return;
		// Filter
		var matcher = this.matcher;
		var results = this.filter(function(model) {
			attributes = attributes && attributes.length ? attributes : _.keys( model.attributes );
			return !_.every( attributes, function( attribute ) {
				return !matcher( keyword, model.get( attribute ) );
			});
		});
		var collection = new Backbone.Collection( results );

		// For use of returning un-async
		return new BookCollection(collection.models);
	},

	// Get all the themes from the collection
	themes: function() {
		var themes = this.toJSON().map(function(book) {
			return book.theme;
		});

		return _.sortBy(_.uniq(_.flatten(themes), false, "name"), "name");
	},

	// Get all the languages from the collection
	languages: function() {
		var languages = this.toJSON().map(function(book) {
			return book.language;
		});

		return _.sortBy(_.uniq(_.flatten(languages)));
	},

	// Get all the countries from the collection
	countries: function() {
		var countries = this.toJSON().map(function(book) {
			return book.country;
		});

		return _.sortBy(_.uniq(countries));
	},

	// Get all the levels from the collection
	levels: function() {
		var levels = this.toJSON().map(function(book) {
			return book.reading_level;
		});

		return _.uniq(levels);
	},

	// Get all the types from the collection
	types: function() {
		var types = this.toJSON().map(function(book) {
			return book.type;
		});

		return _.sortBy(_.uniq(types));
	},

	// Get all the formats from the collection
	formats: function() {
		var formats = this.toJSON().map(function(book) {
			return book.format;
		});

		return _.uniq(_.flatten(formats));
	}
});
